import { LoaderService } from '@core/services/loader.service';
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpHeaders, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { Router } from '@angular/router';
import { tap } from 'rxjs/internal/operators/tap';
import { AuthStatusService } from '@core/services/auth-status.service';
// import { ConnectorService } from '../services/connector.service';
declare var swal: any;

@Injectable()
export class AppHttpInterceptor implements HttpInterceptor {
  private totalRequests = 0;
  constructor(
    private router: Router,
    private loaderService: LoaderService,
    private authStatusService: AuthStatusService
    // private connectorService: ConnectorService
  ) {
  }
  apiUrl = environment.AGGREGATOR_API_ENDPOINT;
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.totalRequests++;
    this.loaderService.display(true);
    const token = localStorage.getItem('token') === undefined ? '' : localStorage.getItem('token');
    if (token) {
      req = req.clone({ headers: req.headers.set('Authorization', token) });
    }
    if (!req.headers.has('Content-Type')) {
      req = req.clone({ headers: req.headers.set('Content-Type', 'application/json') });
    }
    // setting the accept header
    req = req.clone({ headers: req.headers.set('Accept', 'application/json') });

    req = req.clone({ headers: req.headers.set('Access-Control-Allow-Origin', '*') });
    req = req.clone({ headers: req.headers.set('Access-Control-Allow-Credentials', 'true') });

    req = req.clone({ headers: req.headers.set('Response-Time', new Date().getTime().toString())});

    req = req.clone({
      url: `${req.url}`,
    });
    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          // this.connectorService.onResponseReceived(event);
          this.decreaseRequests();
          if(event.body && typeof event.body === 'object'){
            event.body['responseTime'] = (new Date().getTime() - new Date(parseInt(req.headers.get('Response-Time'))).getTime()) / 1000;
          }
          return event;
        }
      }, error => {
        this.decreaseRequests();
        if (error instanceof HttpErrorResponse) {
          if (error.status === 401) {
            this.redirectLogin();
          }
        }
      })
  );
  }

  private decreaseRequests() {
    this.totalRequests--;
    if (this.totalRequests === 0) {
      this.loaderService.display(false);
    }
  }

  redirectLogin() {
    localStorage.clear();
    this.authStatusService.setState(false);
    this.router.navigate(['/login']);
  }
}
